import { ContentContainer } from '@/components/ui/content-container';
import { Paragraph } from '@/components/ui/typography';

interface EmptyStateProps {
  message: string;
}

export function EmptyState({ message }: EmptyStateProps) {
  return (
    <ContentContainer>
      <div className="rounded-lg border border-dashed border-border bg-muted p-12 text-center">
        <Paragraph className="text-muted-foreground">{message}</Paragraph>
      </div>
    </ContentContainer>
  );
}
